import React, { useEffect, useState } from 'react';
import { Users, UserCheck, DollarSign, CalendarClock } from 'lucide-react';
import { motion } from 'framer-motion';
import ReactECharts from 'echarts-for-react';
import KPICard from '../components/dashboard/KPICard';
import ChartCard from '../components/dashboard/ChartCard';
import RecentActivity from '../components/dashboard/RecentActivity';
import { getKpiData, getChartOptions, getRecentActivities } from '../data/mockData';
import useDidFetch from '../custom_hooks/useDidfetch';
import { ROLES } from '../constant/roles';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';
import toast from 'react-hot-toast';
import { getChartDataOptions } from './dashboard/DashboardData';

const AdminDashboard = () => {
    const [activities, setActivities] = useState(getRecentActivities());
    const [count, setCount] = useState({
        "active_trainer": 0,
        "total_members": 0,
        "monthly_revenue": 0,
        "pending_renewals": 0,
        "all_month_revenue": [],
        "member_growth": [],
        "attendance": []
    })

    const chartConfig = {
        revenue: getChartDataOptions('revenue', count),
        attendance: getChartDataOptions('attendance', count),
        growth: getChartDataOptions('growth', count),
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };
    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllUsers();
            getDashboardData();
            // getAllPayments();
        })
    }, []);
    const getDashboardData = async () => {
        try {
            const response = await api.get(`${ENDPOINTS.adminDashboardApi}`);
            const result = response?.data;
            console.log(result);
            setCount(prev => ({ ...prev, total_members: result?.total_users, active_trainer: result?.active_trainers, pending_renewals: result?.renewal_pending_users, monthly_revenue: result?.this_month_revenue, all_month_revenue: result?.all_month_revenue, attendance:result?.attendance,member_growth:result?.member_growth }))
        } catch (error) {
            console.error("getDashboardData error:", error);
        }
    }
    const getAllUsers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUser}`);
            const result = response?.data;
            console.log(response);
            // if (response.status === 200) {
            //     let allusers = result?.users ?? [];
            //     let trainers = allusers.filter((user) => user.role?.name == ROLES.TRAINER && user?.status == 'active');
            //     let members = allusers.filter((user) => user.role?.name == ROLES.MEMBER);
            //     setCount(prev => ({ ...prev, total_members: members.length, active_trainer: trainers.length }))
            // }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    return (
        <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="space-y-8"
        >
            {/* KPI Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <KPICard title="Total Members" value={count.total_members} icon={Users} change="+5.2%" changeType="increase" color="blue" />
                <KPICard title="Active Trainers" value={count.active_trainer} icon={UserCheck} change="+2" changeType="increase" color="green" />
                <KPICard title="Monthly Revenue" value={`${count.monthly_revenue.toLocaleString()} OMR`} icon={DollarSign} change="-1.8%" changeType="decrease" color="orange" />
                <KPICard title="Pending Renewals" value={count.pending_renewals} icon={CalendarClock} change="+12" changeType="increase" color="red" />
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <ChartCard title="Monthly Revenue">
                    <ReactECharts option={chartConfig.revenue} style={{ height: '350px' }} notMerge={true} lazyUpdate={true} />
                </ChartCard>
                <ChartCard title="Attendance Trend">
                    <ReactECharts option={chartConfig.attendance} style={{ height: '350px' }} notMerge={true} lazyUpdate={true} />
                </ChartCard>
            </div>

            <div className="grid grid-cols-1 gap-6">
                <ChartCard title="Member Growth">
                    <ReactECharts option={chartConfig.growth} style={{ height: '350px' }} notMerge={true} lazyUpdate={true} />
                </ChartCard>
            </div>
 
            {/* <RecentActivity activities={activities} />  */}
        </motion.div>
    );
};

export default AdminDashboard;
